import * as Rox from "rox-browser";

export const digital_document_center = {
  ddc_billing_issues: new Rox.Flag(),
  ddc_lien_release: new Rox.Flag()
};
